/* SIMLESS Global — the small amount of behaviour the design actually needs.
   設計稿は React だったが、ストアフロントで状態を持つのは 4 つだけ:
   ハンバーガー / FAQ の開閉 / 商品ページの組み合わせ選択 / 数量。
   FAQ は <details> に寄せたので JS 不要。ここに残るのは 3 つ。 */
(function () {
  'use strict';

  /* --- ハンバーガー ------------------------------------------------------- */
  var burger = document.querySelector('[data-sl-burger]');
  var menu = document.querySelector('[data-sl-menu]');
  if (burger && menu) {
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* --- 国 / 通貨 / 言語の切替 --------------------------------------------- */
  /* 国を選ぶと通貨がその国の物になる（Markets の local currencies）。
     言語は国に従わせるので、送る前に隠し項目へ移し替えて **1 回で** 送る。
     🔴 2 回に分けて送ると途中で「国だけ変わって言語が前のまま」の画面が挟まる。
     JS が無い時は国だけ変わる（通貨は正しくなる）ので壊れはしない。 */
  document.querySelectorAll('[data-sl-loc-country]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.form;
      if (!form) return;
      var option = select.options[select.selectedIndex];
      var locale = form.querySelector('[data-sl-loc-locale]');
      if (locale && option && option.dataset.locale) locale.value = option.dataset.locale;
      form.submit();
    });
  });

  /* --- LINE 相談モーダル（日本の訪客のみ描画される）----------------------- */
  /* 🔴 開いている間は背後をスクロールさせない。モーダルの外が動くと
        「閉じたつもりが別の場所に居る」になる。
     ⚠️ Esc と背景クリックの両方で閉じられるようにする。片方だけだと
        携帯で閉じられない／PC で閉じ方が判らない、のどちらかが起きる。 */
  (function () {
    var root = document.querySelector("[data-sl-line-root]");
    if (!root) return;
    var overlay = root.querySelector("[data-sl-line-overlay]");
    if (!overlay) return;

    function open() {
      overlay.hidden = false;
      document.body.style.overflow = "hidden";
      var c = overlay.querySelector("[data-sl-line-close]");
      if (c) c.focus();
    }
    function close() {
      overlay.hidden = true;
      document.body.style.overflow = "";
    }

    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      if (e.target.closest("[data-sl-line-open]")) {
        e.preventDefault();
        open();
        return;
      }
      if (e.target.closest("[data-sl-line-close]")) {
        close();
        return;
      }
      // 背景（カードの外）を押したら閉じる
      if (!overlay.hidden && e.target === overlay) close();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !overlay.hidden) close();
    });
  })();

  /* --- 数量ステッパー ----------------------------------------------------- */
  document.querySelectorAll('[data-sl-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    if (!input) return;
    box.addEventListener('click', function (e) {
      var step = e.target.closest('[data-sl-step]');
      if (!step) return;
      e.preventDefault();
      // min は 1。0 を許すと Shopify 側で「行を削除」の意味になり、
      // 数量を減らしただけのつもりが商品ごと消える。
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.slStep));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* --- 商品ページの組み合わせ選択 ------------------------------------------
     設計稿の DAYS / DATA は Shopify の 2 つのオプションに対応する。
     選択の組み合わせから variant を引き当て、価格・在庫・hidden id を更新する。
     variant が存在しない組み合わせ（作られていない日数×容量）は
     🔴 黙って買えない状態にせず、ボタンの文言で理由を出す。 */
  var form = document.querySelector('[data-sl-variant-form]');
  if (form) {
    var dataEl = document.getElementById('sl-variant-data');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = form.querySelector('[data-sl-variant-id]');
    var priceEl = form.querySelector('[data-sl-price]');
    var noteEl = form.querySelector('[data-sl-plan-note]');
    var submit = form.querySelector('[data-sl-submit]');
    var moneyFormat = form.dataset.slMoneyFormat || '${{amount}}';

    /* 🔴 **money_format は通貨ごとに placeholder が違う。**
       「小数 2 桁の一般形だけ賄えば足りる」と決め打ちしていたため、EUR の
       `€{{amount_with_comma_separator}}` が置換されず、フランス語の全商品ページで
       価格もカートボタンも **`€{{amount_with_comma_separator}}` と生で出ていた**。
       桁区切りも入れていなかったので ₩7000（正しくは ₩7,000）になっていた。
       Shopify が出しうる 8 種すべてを賄い、知らない物が来ても素の数字に落とす。 */
    function digits(cents, withDecimals, thousands, decimalMark) {
      var neg = cents < 0;
      var n = Math.abs(cents) / 100;
      var s = withDecimals ? n.toFixed(2) : String(Math.round(n));
      var parts = s.split('.');
      var head = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return (neg ? '-' : '') + head + (parts[1] ? decimalMark + parts[1] : '');
    }

    function money(cents) {
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
        switch (key) {
          case 'amount':
            return digits(cents, true, ',', '.');
          case 'amount_no_decimals':
            return digits(cents, false, ',', '');
          case 'amount_with_comma_separator':
            return digits(cents, true, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return digits(cents, false, '.', '');
          case 'amount_with_apostrophe_separator':
            return digits(cents, true, "'", '.');
          case 'amount_no_decimals_with_space_separator':
            return digits(cents, false, ' ', '');
          case 'amount_with_space_separator':
            return digits(cents, true, ' ', ',');
          case 'amount_with_period_and_space_separator':
            return digits(cents, true, ' ', '.');
          default:
            return digits(cents, true, ',', '.');
        }
      });
    }

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll('[data-sl-option]'), function (group) {
        var on = group.querySelector('input:checked');
        return on ? on.value : null;
      });
    }

    function has(probe) {
      return variants.some(function (v) {
        return (
          v.available &&
          probe.every(function (o, i) {
            return o === null || v.options[i] === o;
          })
        );
      });
    }

    /* 売っていない組み合わせに取り消し線を引く。
       🔴 **disabled にはしない。** 押せなくすると「日数を先に変えてから容量を選ぶ」
          ができず行き止まりになる（180日 × 無制限 が無い時、無制限を選んだままでは
          どの日数へも移れなくなる）。押せるが線が引いてある、が正しい。 */
    function markAvailability() {
      var want = selected();
      Array.prototype.forEach.call(form.querySelectorAll('[data-sl-option]'), function (group, gi) {
        Array.prototype.forEach.call(
          group.querySelectorAll('input[type="radio"]'),
          function (input) {
            var probe = want.slice();
            probe[gi] = input.value;
            var ok = has(probe);
            var label = input.nextElementSibling;
            if (label) label.classList.toggle('is-unavailable', !ok);
            input.setAttribute('aria-disabled', ok ? 'false' : 'true');
          },
        );
      });
    }

    function sync() {
      markAvailability();
      var want = selected();
      var match = variants.find(function (v) {
        return want.every(function (o, i) {
          return o === null || v.options[i] === o;
        });
      });

      if (!match) {
        /* 🔴 価格と注記も消す。ここで前の variant の値を残すと、
           「$14.00 / 180 · 10GB」と出したまま無制限が選択中、という
           画面上で矛盾した状態になる（実際にそうなっていた）。 */
        if (priceEl) priceEl.textContent = '—';
        if (noteEl) noteEl.textContent = want.filter(Boolean).join(' · ');
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.dataset.slUnavailable;
        }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (noteEl) noteEl.textContent = match.options.filter(Boolean).join(' · ');
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available
          ? submit.dataset.slAdd + ' — ' + money(match.price)
          : submit.dataset.slSoldOut;
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-sl-option]')) sync();
    });
    sync();
  }
})();
